<form #form="ngForm" autocomplete="off">
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <ui-rich-text
                name="applicantConsent"
                #applicantConsent="ngModel"
                [(ngModel)]="jobPosting.applicantConsent"
                height="100px"
                [stripNewlines]="true"
                [minlength]="41"
                [useMiniToolbar]="true"
            ></ui-rich-text>
            <mat-error *ngIf="applicantConsent.invalid">{{
                'applicant-tracker.consentCharactersLimit' | translate
            }}</mat-error>
        </mat-form-field>
    </div>
</form>
